export default __webpack_public_path__ + "e6f5d435b15218695c2bb434dd075842.png";